import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import config from '../config';
import '../components/attendance.css';
import '../components/Navbar.css';

const Attendance = () => {
  const [user, setUser] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
      checkAttendance(storedUser.id);
    } else {
      setLoading(false);
      setError('User not found. Please log in.');
    }
  }, []);

  const checkAttendance = async (userId) => {
    try {
      setLoading(true);
      const currentDate = new Date().toISOString().split('T')[0];
      const response = await axios.get(`${config.API_BASE_URL}/attendance/${userId}/date/${currentDate}`);
      console.log('API response:', response.data); // Log the API response
      setAttendanceStatus(response.data[0] || null); // Take the first item if it exists
    } catch (error) {
      console.error('Error checking attendance:', error);
      setError('Failed to check attendance status');
    } finally {
      setLoading(false);
    }
  };

  const markAttendance = async (type) => {
    try {
      setLoading(true);
      const currentDate = new Date().toISOString().split('T')[0];
      const currentTime = new Date().toISOString();
      
      let endpoint = `${config.API_BASE_URL}/attendance`;
      let data = {
        userId: user.id,
        date: currentDate,
      };

      if (type === 'start') {
        data.starttime = currentTime;
      } else if (type === 'stop') {
        data.starttime = attendanceStatus.starttime;
        data.endtime = currentTime;
      }

      const response = await axios.post(endpoint, data);
      setAttendanceStatus(response.data);
    } catch (error) {
      console.error('Error marking attendance:', error);
      setError(`Failed to mark ${type} time`);
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return 'Not marked';
    try {
      // Create a date object from the UTC time string
      const date = new Date(timeString);
      
      // Convert to IST (UTC+5:30)
      const istOptions = { 
        timeZone: 'Asia/Kolkata',
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      };
      
      return date.toLocaleTimeString('en-IN', istOptions);
    } catch (error) {
      console.error('Error formatting time:', error);
      return 'Invalid time';
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!user) {
    return <div>Please log in to view attendance.</div>;
  }

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="navbar-brand">Attendance System</div>
        <div className="navbar-menu">
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/profile">Profile</Link>
          <button onClick={() => {/* Add logout logic here */}}>Logout</button>
        </div>
      </nav>

      <div className="main-container">
        <main className="content">
          <div className="attendance-container">
            <h1>Attendance for {user.name}</h1>
            <div className="attendance-status">
              <p>Date: {new Date().toLocaleDateString()}</p>
              <p>Start Time: {formatTime(attendanceStatus?.starttime)}</p>
              <p>Stop Time: {formatTime(attendanceStatus?.endtime)}</p>
            </div>
            <div className="attendance-actions">
              {!attendanceStatus?.starttime && (
                <button onClick={() => markAttendance('start')}>Start Work</button>
              )}
              {attendanceStatus?.starttime && !attendanceStatus?.endtime && (
                <button onClick={() => markAttendance('stop')}>Stop Work</button>
              )}
              {attendanceStatus?.starttime && attendanceStatus?.endtime && (
                <p>Your work hours have been recorded for today.</p>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Attendance;
